const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Marcellus&family=Mulish:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap';

let fontsLoaded = false;

function ensureFonts() {
  if (fontsLoaded || typeof document === 'undefined') {
    return;
  }

  const existing = document.querySelector(`link[data-yoga-booking-fonts="true"]`);
  if (existing) {
    fontsLoaded = true;
    return;
  }

  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect1);

  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = FONT_HREF;
  link.dataset.yogaBookingFonts = 'true';
  document.head.appendChild(link);

  fontsLoaded = true;
}

export { ensureFonts };
